import { fmtPrice } from '@upstart/harmony/lib/formatter';
import { isNil } from 'lodash';

export const formatRate = rate => parseFloat(rate?.toFixed(8));

/**
 * Truncates rate value to 8 decimals accounts for null, number, or other string values like "", "0." or "." that result from calling this onBlur
 * @param value
 * @param precision
 * @return string
 */
export const formatRateWithPrecision = (value, precision) => {
  if (value) {
    const rate = value.toString();
    const [, decimals] = rate.split('.');

    return decimals?.length > precision
      ? parseFloat(rate).toFixed(precision)
      : rate;
  }
  return value;
};

export const formatCurrency = number =>
  number < 0 ? `-${fmtPrice(-number)}` : fmtPrice(number);

export const parseNumber = number => {
  if (isNil(number) || Number.isNaN(number)) {
    return undefined;
  }

  const parsedNumber = parseInt(number, 10);

  return isNaN(parsedNumber) ? undefined : parsedNumber;
};
